/* global window */

'use strict';

function sendViewDurationBeacon(beaconUrl, articleId, startTime) {
    let referrer = document.referrer || '';
    window.addEventListener('pagehide', () => {
        if (navigator && navigator.sendBeacon) {
            let data = new FormData();
            data.append('dur', performance.now() - startTime);
            data.append('art_id', articleId);
            data.append('rf', encodeURIComponent(referrer));
            navigator.sendBeacon(beaconUrl, data);
        }
    });
}

module.exports = {
    sendViewDurationBeacon: sendViewDurationBeacon,
};
